import HomeView from './components/HomeView.vue';
import AdminView from './components/AdminView.vue';

export default [{
  path: '/',
  component: HomeView
}, {
  path: '/admin',
  component: AdminView
}];